module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_pasta_cacahuate.e7bf5f45.pdf";